$(document).on('change', 'variant-radios-list .swatch-options', function (e) {
    var variants = {};
    variants["productId"] = $(this).parents("variant-radios-list").attr("data-product-id");
    variants["sectionId"] = $(this).parents("variant-radios-list").attr("data-section");
    variants["productVariants"] = JSON.parse($("#product-" + variants.productId).html());
    var radioButtonSelection = variants.sectionId + '-' + variants.productId;
    variants["position"]= $(this).attr("option-position");
    variants["type"] = $(this).attr("option-type");
    variants["combination"] = $(this).val();
    variants["variantImages"] = {};
    
    $.each(variants.productVariants, function (key, val) {
        var option = `option${variants.position}`;
        if(val[`${option}`] == variants.combination){
            variants.variantImages[variants.combination] = {
                imageUrl: val.featured_image ? val.featured_image.src : null,
                id: val.id,
                price: val.price,
                available: val.available,
            };
            return false;
        }
    });
    var productImgEl = $("div[data-product-id*=" + radioButtonSelection + "] img").first();
    var currentImgSrc = productImgEl.attr("src").split("&width=")[0];
    var selectedVariant = variants.variantImages[variants.combination];

    // Remove any existing "Sold Out" message
    $("div[data-product-id*=" + radioButtonSelection + "] .product-item-badges").remove();

    if (selectedVariant.imageUrl && variants.type == "color") {
        var newImgSrc = selectedVariant.imageUrl;
        productImgEl.attr("srcset", function (key, val) {
            return val.replaceAll(currentImgSrc, newImgSrc);
        });
        productImgEl.attr("src", newImgSrc);
    }

    var productVariantToCartFormEl = $("div[data-product-id*=" + variants.productId + "] product-form input[name=id]");
    productVariantToCartFormEl.attr("value", selectedVariant.id);

    var productPrice = $("div[data-product-id*=" + radioButtonSelection + "] span.price").first();
    var newPrice = selectedVariant.price;
    productPrice.html(Shopify.formatMoney(newPrice));

    // Show the price element if it was hidden
    productPrice.show();

    if (!selectedVariant.available) {
        // Show the "Sold Out" message
        var soldOutMessage = '<div class="product-item-badges"><span class="soldout">Sold Out</span></div>';
        $("div[data-product-id*=" + radioButtonSelection + "] .product-item-img").after(soldOutMessage);
    }

    e.stopPropagation();
});